export const REQUEST_MORE_FEED_RESULT = 'REQUEST_MORE_FEED_RESULT'
export const RECEIVE_MORE_FEED_RESULT = 'RECEIVE_MORE_FEED_RESULT'
export const HANDLE_MORE_FEED_RESULT_ERROR = 'HANDLE_MORE_FEED_RESULT_ERROR'

function requestMoreFeedResult (): Object {
  return {
    type: REQUEST_MORE_FEED_RESULT
  }
}

function receiveMoreFeedResult (result): Object {
  return {
    type: RECEIVE_MORE_FEED_RESULT,
    result
  }
}

function handleMoreFeedResultError (error): Object {
  return {
    type: HANDLE_MORE_FEED_RESULT_ERROR,
    error
  }
}

function handleError (response) {
  if (!response.ok) {
    throw Error(response.statusText)
  }
  return response
}

export function fetchMoreFeedResult () {
  return (dispatch, getState) => {
    dispatch(requestMoreFeedResult())
    const { data, feed } = getState()
    const { host, path, projectId, limit, moderation } = data.sombiFeed
    const page = feed.page + 1
    const url = `https://${host}/${path}/document?projectId=${projectId}&limit=${limit}&moderation=${moderation}&page=${page}`
    fetch(url, { method: 'GET' })
      .then((res) => handleError(res).json())
      .then((data) => dispatch(receiveMoreFeedResult(data._embedded.document)))
      .catch((err) => dispatch(handleMoreFeedResultError(err)))
  }
}



// WEBPACK FOOTER //
// ./src/shared/actions/feed.js